import React from 'react';
import styled from "styled-components";
import { DocumentDetailsCard } from "../utilities/DocumentDetailsCard";
import { EmailAttachment } from "./types";

export type EmailAttachmentsProps = {
    attachments: EmailAttachment[]
    onOpenAttachment: (attachment: EmailAttachment) => void
};

const EmailAttachmentContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;

    & > * {
        flex: 1 1 25%;
    }
`;

const EmailAttachments = ({ attachments, onOpenAttachment }: Readonly<EmailAttachmentsProps>) => {
    if (attachments.length === 0) {
        return null;
    }
    return (
        <EmailAttachmentContainer className="mb-2">
            {attachments.map((a) => (
                <DocumentDetailsCard
                    key={a.id}
                    fileName={a.name}
                    fileSize={a.size}
                    type={a.type}
                    isClearable={true}
                    className="has-pointer"
                    clearIcon={['fas', 'download']}
                    clearIconVariant={'muted'}
                    clearTooltipText={'Download'}
                    clearFile={() => onOpenAttachment(a)}
                    onClick={() => onOpenAttachment(a)}
                />
            ))}
        </EmailAttachmentContainer>
    );
};

export default EmailAttachments;